module.exports = __webpack_public_path__ + "static/media/img2.b931dd24.jpg";